import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectLogsRecent() {
  const recent = [
    {
      id: '1',
      title: 'Cập nhật tiến độ công việc',
      sub: 'Thi công móng hầm',
      user: 'Nguyễn Văn An',
      time: '30/05/2024 10:30',
      icon: 'ri-task-line',
      color: 'text-emerald-500',
      bg: 'bg-emerald-50'
    },
    {
      id: '2',
      title: 'Tải lên tài liệu mới',
      sub: 'Biên bản nghiệm thu móng hầm',
      user: 'Trần Thị Mai',
      time: '30/05/2024 09:15',
      icon: 'ri-file-text-line',
      color: 'text-blue-500',
      bg: 'bg-blue-50'
    },
    {
      id: '3',
      title: 'Phê duyệt yêu cầu vật tư',
      sub: 'Thép xây dựng D16',
      user: 'Lê Hoàng Nam',
      time: '29/05/2024 16:45',
      icon: 'ri-checkbox-circle-line',
      color: 'text-emerald-600',
      bg: 'bg-emerald-50'
    }
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Hoạt động gần đây</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>

      <div className="space-y-5">
        {recent.map((item) => (
          <div key={item.id} className="flex gap-3 group cursor-pointer relative">
             <div className={cn("w-7 h-7 rounded-full flex items-center justify-center shrink-0 z-10 group-hover:scale-110 transition-transform", item.bg, item.color)}>
                <i className={cn(item.icon, "text-sm")} />
             </div>
             <div className="space-y-0.5 min-w-0 flex-1">
                <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{item.title}</h4>
                <p className="text-xs font-normal text-slate-400 truncate">{item.sub}</p>
                <div className="flex justify-between items-center text-xs font-normal text-slate-400 mt-1">
                   <span>{item.user}</span>
                   <span>{item.time}</span>
                </div>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
